import httpClient from '../../../clientSideServices/http';
import { IAccessRequestData } from '../CustomComponent/RDUSGCustomComponent/RequestAccessForm';

export const registerAccessForm = (
  formData: IAccessRequestData,
  storeId: string
): Promise<any> => {
  return httpClient.post('/api/registerAccess', { ...formData, storeId });
};
